import React, { useState } from 'react';
import {
  Box, Button, Divider, Typography,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import EventIcon from '@mui/icons-material/Event';
import useRUMView from 'common-datadog/useRUMView';
import Screen from '../Screen';
import useApplication from '../../resources/applications/read';
import { currencyFormat } from '../../constants';
import InstallmentAutoPay from '../InstallmentAutoPay';
import IconListItem from '../IconListItem';
import InstallmentManualPayments from '../InstallmentManualPayments';

const InstallmentPaymentOptions = () => {
  useRUMView('installment-payment-options');
  const { data: application } = useApplication();
  const [paymentType, setPaymentType] = useState(null);

  if (paymentType === 'AUTO') {
    return <InstallmentAutoPay />;
  }

  if (paymentType === 'MANUAL') {
    return <InstallmentManualPayments setupAutopay={() => setPaymentType('AUTO')} />;
  }

  return (
    <Screen header="Enroll in autopay for your monthly payments.">
      <Box>
        <Typography variant="body2" sx={{ mb: '8px' }}>
          Your monthly payment:
        </Typography>
        <Typography variant="h1" color="secondary">
          {currencyFormat.format(application.attributes.final_loan.data.attributes.payment)}
        </Typography>
      </Box>
      <Typography variant="h4" textAlign="left">
        How autopay works
      </Typography>
      <Box sx={{
        display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'start', mb: 3,
      }}
      >
        <IconListItem
          Icon={AccountBalanceIcon}
          text="Quickly and securely add your bank account."
        />
        <IconListItem
          Icon={MonetizationOnOutlinedIcon}
          text="We'll process your payment automatically each month, helping you avoid late fees!"
        />
        <IconListItem
          Icon={EventIcon}
          text="Easily change the payment date and amount within your portal."
        />
      </Box>
      <Button
        fullWidth
        variant="contained"
        onClick={() => setPaymentType('AUTO')}
        startIcon={<LockIcon size={18} />}
      >
        Enroll in Autopay
      </Button>
      <Button
        fullWidth
        variant="text"
        onClick={() => setPaymentType('MANUAL')}
      >
        I&apos;ll Make Manual Payments
      </Button>
      <Box
        variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: '#FAFAFA',
          p: 2,
          borderRadius: '16px',
        }}
      >
        <Typography variant="h1" color="secondary">“</Typography>
        <Typography variant="subtitle2">
          It was a wonderful experience.
        </Typography>
        <Typography variant="body2">
          We got the funds very quickly and paid off the loan early because of the
          automatic payments. Thanks for the help!
        </Typography>
        <Divider sx={{ mt: 2, mb: 2, width: '50%' }} />
        <Typography variant="subtitle2">
          Bernie B.
        </Typography>
      </Box>
    </Screen>
  );
};

export default InstallmentPaymentOptions;
